import { render } from "./appuntamentiOfDateModal.vue?vue&type=template&id=773120b2&scoped=true&ts=true"
import script from "./appuntamentiOfDateModal.vue?vue&type=script&lang=ts"
export * from "./appuntamentiOfDateModal.vue?vue&type=script&lang=ts"

import "./appuntamentiOfDateModal.vue?vue&type=style&index=0&id=773120b2&scoped=true&lang=css"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773120b2"]])

export default __exports__